import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmtINR = (v) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(Number(v || 0));

export const fmtNum = (v) =>
  new Intl.NumberFormat("en-IN").format(Number(v || 0));

export const ROLES = {
  admin: "Administrator",
  centre_manager: "Centre Manager",
  centre_coordinator: "Centre Coordinator",
  project_head: "Project Head",
  director: "Director",
  finance: "Finance Team",
  ho_approver: "Head Office",
  accounts: "Accounts",
  mis: "MIS (Income Entry)",
  other: "Other",
};

export const STATUS_COLORS = {
  submitted: "bg-amber-100 text-amber-900 border-amber-300",
  resubmitted: "bg-amber-100 text-amber-900 border-amber-300",
  approved: "bg-emerald-100 text-emerald-900 border-emerald-300",
  paid: "bg-zinc-900 text-white border-zinc-900",
  rejected: "bg-rose-100 text-rose-900 border-rose-300",
  sent_back: "bg-orange-100 text-orange-900 border-orange-300",
  partially_paid: "bg-blue-100 text-blue-900 border-blue-300",
};

export const STATUS_LABEL = {
  submitted: "Submitted",
  resubmitted: "Resubmitted",
  approved: "Approved",
  paid: "Paid",
  rejected: "Rejected",
  sent_back: "Sent Back",
  partially_paid: "Partially Paid",
};
